module.exports = __webpack_public_path__ + "static/img/contant_4.1c5dd35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_7/contant_4.jpg
// module id = AABb
// module chunks = 0